import reviewsService from "@/services/reviews";
import serviceHandler from "@/helpers/handlers/service";

import moment from "moment";
import { FORMAT } from "@/config/date-format";
import ErrorHandler from "@/helpers/handlers/error";

export default {
  async fetchReviews({ commit }, { payload, searchMode = false }) {
    if (!payload.only_count) {
      commit("SET_LOADING", true);
    }
    try {
      const reviewsData = await serviceHandler(
        searchMode
          ? reviewsService.reviewsSearch(payload)
          : reviewsService.getReviews(payload)
      );

      if (!payload.reply && payload.only_count) {
        commit("SET_ALL_REVIEWS_TOTAL_COUNT", reviewsData.count);
        return;
      }
      commit("SET_REVIEWS_DATA", reviewsData);
    } catch (error) {
      ErrorHandler.displayError(error);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async postReply({ commit }, payload) {
    const review = await reviewsService.postReply(payload);
    commit("SET_REPLIED_REVIEW", review.data);
    return review;
  },
  async postBulkReply({ dispatch }, payload) {
    await serviceHandler(reviewsService.postBulkReply(payload));

    dispatch("handleBulkReply", payload);
  },
  async deleteReply({ commit }, payload) {
    await serviceHandler(reviewsService.deleteReply(payload));

    commit("DELETE_REPLIED_REVIEW", payload.id);
  },

  handleBulkReply({ commit, state }, { ids, reply }) {
    const reviews = [...state.data.results];

    reviews.forEach(review => {
      if (ids.includes(review.id)) {
        review.reply_comment = reply;
        review.reply_update_time = moment().format(FORMAT.DATE_HMS);
        review.processing_in_progress = true;
      }
    });

    commit("SET_REVIEWS", reviews);
  },
  setSelectedItems({ commit }, payload) {
    commit("SET_SELECTED_ITEMS", payload);
  },
  setAllItemsSelected({ commit }, payload) {
    commit("SET_ALL_ITEMS_SELECTED", payload);
  },
  setIsAiReplyInProgress({ commit }, payload) {
    commit("SET_IS_AI_REPLY_IN_PROGRESS", payload);
  }
};
